
import { supabase } from "@/integrations/supabase/client";
import { logClaudeApiInteraction } from "../logging/claudeApiLogger";
import { getFallbackWord } from "../claude";

/**
 * Handle fallback words when primary word selection fails
 */
export const handleFallbackWords = async (usedWordsArray: string[], error?: Error | null, gameId?: string, roundNumber?: number) => {
  // First try to get a random word from the database
  try {
    console.log("Attempting to get random word from database as fallback");
    
    // Try to get a random word from the database using the RLS bypass function
    const { data: randomWord, error: randomWordError } = await supabase.rpc(
      'get_random_unused_word_bypass_rls',
      { used_words: usedWordsArray.map(w => w.toLowerCase()) }
    );
    
    if (!randomWordError && randomWord) {
      console.log(`Got random word from database as fallback: ${randomWord}`);
      
      await logClaudeApiInteraction(
        gameId || null,
        roundNumber || null,
        'word_options',
        { usedWords: usedWordsArray },
        { randomWord },
        error,
        error ? 500 : 200,
        null,
        true,
        error ? `Error: ${error.message}` : "Using random word as fallback"
      );
      
      return { 
        nextAiWord: randomWord,
        explanation: "I chose a random word because I couldn't think of a good connection.",
        proximity: 40 // Default proximity for random words
      };
    }
  } catch (randomError) {
    console.error("Error with random word fallback:", randomError);
    // If random word fails, continue to using the hardcoded fallback words
  }
  
  // If random word selection fails, use the standard fallback mechanism
  const fallbackOption = getFallbackWord(usedWordsArray, error);
  
  // Log the fallback usage
  logClaudeApiInteraction(
    gameId || null,
    roundNumber || null,
    'word_options',
    { usedWords: usedWordsArray },
    { fallbackWord: fallbackOption.word, fallbackExplanation: fallbackOption.explanation },
    error,
    error ? 500 : 200,
    null,
    true,
    error ? `Error: ${error.message}` : "All suggested words already used"
  );
  
  return { 
    nextAiWord: fallbackOption.word,
    explanation: fallbackOption.explanation,
    proximity: 45 // Default proximity value for fallback
  };
};
